// extracted by mini-css-extract-plugin
module.exports = {"cardsWrapper":"search-page_cardsWrapper__80tRR","card":"search-page_card__6Hk0W"};